import 'owl.carousel';
import 'bootstrap';
import 'jquery-validation';
import 'daterangepicker';
import 'slick-slider';
var moment = require('moment');

$('.dataclick').daterangepicker({
    timePicker: false,
    startDate: moment().startOf('hour'),
    endDate: moment().startOf('hour').add(32),
    autoUpdateInput: false,
    opens: 'center',
    locale: {
        format: 'D/M/YYYY',
        "separator": " - ",
        "applyLabel": "Aplicar",
        "cancelLabel": "Cancelar",
        "fromLabel": "DE",
        "toLabel": "HASTA",
        "autoUpdateInput": true,
        "customRangeLabel": "Custom",
        "daysOfWeek": [
            "Dom",
            "Lun",
            "Mar",
            "Mie",
            "Jue",
            "Vie",
            "Sáb"
        ],
        "monthNames": [
            "Enero",
            "Febrero",
            "Marzo",
            "Abril",
            "Mayo",
            "Junio",
            "Julio",
            "Agosto",
            "Septiembre",
            "Octubre",
            "Noviembre",
            "Diciembre"
        ],
    }
},  function(start, end, label) {

    //console.log("A new date selection was made: " + start.format('YYYY-MM-DD') + ' to ' + end.format('YYYY-MM-DD'));


    $('#end-date').val(end.format('YYYY-MM-DD'));
    $('#start-date').val(start.format('YYYY-MM-DD')).trigger('change');

    $('.dataclick').text(start.format('DD/MM/YYYY') + ' - ' + end.format('DD/MM/YYYY'));
});

$(".departamentor, .departamento").on('change', function(e) {
    e.preventDefault();

    let $city = $('.ciudadr, .ciudad');
    let $form = $((this).closest("form"));

    $city.empty().trigger('change');
    $city.prop('disabled', true);

    $.ajax({
        method: 'GET',
        url: $form.attr('action'),
        data: {
            'action':'async_cities_by_department',
            'department_id': $(this).val()
        }
    }).done(function(response) {
        if (response.success) {
            $city.append($('<option>', {
                value: '',
                text: 'Ciudad*'
            }));

            $.each(response.data, function(index, item) {
                var newOption = new Option(item.Nombre, item.Id, false, false);
                $city.append(newOption).trigger('change');
            });

            $city.prop('disabled', false);
        }

        if ($city.val() == '' && typeof city_id !== 'undefined') {
            $('.ciudadr, .ciudad').val(city_id).trigger('change');
        }
    })

});

$(".departamentor, .departamento").trigger('change');

// open nav
$('header').on('click', '.mobile-open', function() {
    $(this).toggleClass('active');

    if($(this).hasClass('active')) {
        $(this).find('.lni').addClass('lni-close').removeClass('lni-menu');
        $('.navigation-mobile').fadeIn(400).css('display', 'flex');
    } else {
        $(this).find('.lni').removeClass('lni-close').addClass('lni-menu');
        $('.navigation-mobile').fadeOut(400);
    }
});

$('.page-general__slider-home .owl-carousel').owlCarousel({
    loop: true,
    nav: false,
    dots: true,
    margin: 0,
    items: 1,
    smartSpeed: 2000,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: false
});

$(window).on('load', function() {
    /*$('.slider-tags').owlCarousel({
        loop: false,
        nav: true,
        center: true,
        margin: 15,
        items: 1,
        dots: false,
        smartSpeed: 2000,
        autoWidth: true,
        navText: ["<div class=''><span class='lnr lnr-chevron-left'></span></div>", "<div class=''><span class='lnr lnr-chevron-right'></span></div>"],
        responsive: {
            0: {
               items: 1
            },
            600: {
               items: 1
            },
            1000: {
                items: 1
            },
            1680: {
                items: 1
            }
        }
    });*/
});

$(function() {
    $('.slider-tags').slick({
        infinite: false,
        variableWidth: true,
        slidesToShow: 10,
        slidesToScroll: 1,
        centerMode: false,
        swipe: true,
        prevArrow: "<div class='slick-prev'><span class='lnr lnr-chevron-left'></span></div>",
        nextArrow: "<div class='slick-next'><span class='lnr lnr-chevron-right'></span></div>",
      // swipeToSlide: true,
        responsive: [
            {
                breakpoint: 680,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
        ],
    });
    
  $('.carousel').on('afterChange', function(event, slick, currentSlide, nextSlide){
    console.log(currentSlide);
  });
  
});


$(window).on('load', function() {
    if($('.slider-tags').find('.owl-item').length > 15) {
        $('.slider-tags').addClass('show-arrows');
    }
});

$('.copy-href-to-clipboard').on('click', function (e) {
    e.preventDefault();

    var copyText = $(this).attr('href');
    document.addEventListener('copy', function(e) {
       e.clipboardData.setData('text/plain', copyText);
       e.preventDefault();
    }, true);
    var __this = $(this);
    __this.append( "<small>¡Copiado!</small>" );
    setTimeout(function() {
        __this.find("small").remove();
    },1500);
    document.execCommand('copy');
});

/* open search */
$('.open-search, .search-mobile').on('click', function(e){
    e.preventDefault();
    $('.modal__search').css('display','flex').fadeIn(600);
    $('.modal__search').find('input').focus();
});

$('.close-m').on('click', function(e){
    e.preventDefault();
    $('.modal__search').fadeOut(300);
});

$('header').on('click', '.box-profile', function() {
    var total = 0;
    $(this).next().fadeIn(100);
    $(this).next().find('li').each(function(i){
        console.log(i);
        if(i <= 3) {
          total += $(this).innerHeight() + 1.3;
        }
    });
    $(this).toggleClass('open-nav');
    if($(this).hasClass('open-nav')){
        $(this).next().find('ul').css('height',total+'px');
    } else {
        $(this).next().find('ul').css('height','0px');
        $(this).next().fadeOut(400);
    }
});

$('.mega-acordeon .acordeon .title').on('click', function(){
    $(this).next().slideDown(600).css('display','flex');
    $(this).slideUp(600).fadeOut(600);
    $('.mega-acordeon .acordeon .title').not(this).slideDown(600);
    $('.mega-acordeon .acordeon .title').not(this).next().slideUp(600).fadeOut(600);
});
$('.mega-acordeon .content .icon').on('click', function(){
    $(this).parents('.content').prev().css('display','flex').fadeIn(600);
    $(this).parents('.content').slideUp(600);
});

/**
 * Custom rules
 */

 $('input.specialty').on('change', function() {
    let $this = $(this);
    let $parent = $this.closest('div.form-group');

    if ($this.data('unique')) {
        if ($this.is(':checked')) {
            $parent.find('input[type="checkbox"]').not($this).prop('checked', false);
            $parent.find('input[type="checkbox"]').not($this).attr("disabled", true);
        } else {
            $parent.find('input[type="checkbox"]').not($this).attr("disabled", false);
        }
    }
    var val = $(this).val();
    if(val == 17 || val == 18 || val == 20) {
        $('.question-parent').fadeOut(0);
        $('.question-parent').next('.separator').fadeOut(0);
    } else {
        $('.question-parent').fadeIn(0);
        $('.question-parent').next('.separator').fadeIn(0);
    }
});

$(function() {
    $('#document-type').on('change', function() {
        let $this = $(this);
        let $documentNumber = $('#document-number');

        console.log('documentNumber', $documentNumber);

        if ($this.val() == '1') {
            $documentNumber.rules('add', {
                required: true,
                documentId:true,
                document:false
            });
        }
        else {
            $documentNumber.rules('add', {
                required: true,
                documentId:false,
                document:true
            });
        }
    });
});

$.validator.addMethod("documentId", function (value, element) {
    let pattern = /^[1-9][0-9]+$/g;

    return this.optional(element) || pattern.test(value);
  }, "El documento debe contener solo números y no puede iniciar con 0");

 $.validator.addMethod("document", function (value, element) {
    let pattern = /^[1-9A-Za-z][0-9A-Za-z]*/ig;

    return this.optional(element) || pattern.test(value);
}, "El documento no puede iniciar con 0");

$.validator.addMethod("cell_phone", function (value, element) {
    let pattern = /^[+ 0-9]+$/ig;

    return this.optional(element) || pattern.test(value);
}, "No es un número válido");

$.validator.addMethod("password", function (value, element) {
    let pattern = /^(?=.*[A-Za-z])(?=.*[0-9])(?=.{8,})/g;

    return this.optional(element) || pattern.test(value);
}, "Mínimo 8 caracteres, tener mínimo 1 letra y un número");

$.validator.addMethod("names", function (value, element) {
    let pattern = /^[A-Za-zÀ-ÿ\\u00f1\\u00d1][A-Za-zÀ-ÿ\\u00f1\\u00d1 ]+$/;

    return this.optional(element) || pattern.test(value);
}, "No es un nombre válido");

/*
  step
*/
var providers = [
    'gmail.com',
    'yahoo.com',
    'outlook.com',
    'hotmail.com',
    'sena.edu.co',
    'misena.edu.co',
    'outlook.com',
    'aol.com',
];
if($('#email').length) {
    var datalist   = document.createElement('datalist'),
        emailInput = document.getElementById('email'),
        listReady  = false,
        option;

        var createOption = function(optionVal) {
            option = document.createElement('option');
            option.appendChild(document.createTextNode(optionVal));
            return option;
        };

        var addOption = function(val) {
            providers.forEach(function(i) {
                datalist.appendChild(createOption(val + i));
            })
        };
        if (typeof emailInput.addEventListener != 'undefined') {
            emailInput.addEventListener('keyup', function(e) {
            if (e.keyCode === 50 || e.keyCode === 220) {
                datalist.id = email.getAttribute('list');
                document.body.appendChild(datalist);
                listReady = true;
            }
            if (listReady) {
                datalist.innerHTML = '';
                addOption(this.value.replace(/@.+$/, '@'));
            }
        }, false);
    }
}

$('#sign-in-form').validate({
    errorPlacement: function(error, element) {
        if (error.text() != '') {
            element.parents('.form-group').next('.msn').fadeIn(0).text(error.text());
            element.addClass("is-invalid");
            //$('input, textarea').placeholder();
        }
    },
    unhighlight: function (element) {
        $(element).removeClass("is-invalid");
        $(element).parents('.form-group').next('.msn').fadeOut(0).text('');
    },
    success : function(label, element){
        $(element).removeClass("is-invalid");
        $(element).parents('.form-group').next('.msn').fadeOut(0).text('');
    },
    rules: {
        document_type: {
            required: true
        },
        document_number: {
            required: true
        },
        password: {
            required: true
        }
    },
    messages: {
        document_type: {
            required: "Este campo es requerido",
        },
        document_number: {
            required: "Este campo es requerido",
        },
        password: {
            required: "Este campo es requerido",
        }
    }
});

$('#profile-form').validate({
    errorPlacement: function(error, element) {
        if (error.text() != '') {
            element.parents('.form-group').next('.msn').fadeIn(0).text(error.text());
            element.addClass("is-invalid");
            //$('input, textarea').placeholder();
        }
    },
    unhighlight: function (element) {
        $(element).removeClass("is-invalid");
        $(element).parents('.form-group').next('.msn').fadeOut(0).text('');
    },
    success : function(label, element){
        $(element).removeClass("is-invalid");
        $(element).parents('.form-group').next('.msn').fadeOut(0).text('');
    },
    rules: {
        first_name: {
            required: true,
            names:true
        },
        second_name: {
            names:true
        },
        firts_last_name: {
            required: true,
            names:true
        },
        second_last_name: {
            names:true
        },
        cell_phone_1: {
            cell_phone: true,
            required: true,
            minlength: 10
        },
        email: {
            required:true,
            email:true
        },
        department: {
            required: true
        },
        city: {
            required: true
        },
        'specialty[]': {
            required: true
        }
    },
    messages: {
        first_name: {
            required: "Este campo es requerido",
        },
        second_name: {
            required: "Este campo es requerido",
        },
        firts_last_name: {
            required: "Este campo es requerido",
        },
        second_last_name: {
            required: "Este campo es requerido",
        },
        email: {
            required: "Este campo es requerido",
            email: "El correo no es válido"
        },
        cell_phone_1: {
            required: "Este campo es requerido",
            minlength: "Mínimo {0} caracteres"
        },
        department: {
            required: "Este campo es requerido",
        },
        city: {
            required: "Este campo es requerido",
        },

        'specialty[]': {
            required: "Este campo es requerido",
        },
    }
});
$('#quick-register-form').validate({
    errorPlacement: function(error, element) {
        if (error.text() != '') {
            element.parents('.form-group').next('.msn').fadeIn(0).text(error.text());
            element.addClass("is-invalid");
            //$('input, textarea').placeholder();
        }
    },
    unhighlight: function (element) {
        $(element).removeClass("is-invalid");
        $(element).parents('.form-group').next('.msn').fadeOut(0).text('');
    },
    success : function(label, element){
        $(element).removeClass("is-invalid");
        $(element).parents('.form-group').next('.msn').fadeOut(0).text('');
    },
    rules: {
        document_type: {
            required: true
        },
        document_number: {
            required: true
        },
        first_name: {
            required: true,
            names:true
        },
        last_name: {
            required: true,
            names:true
        },
        cell_phone_1: {
            required: true,
            cell_phone: true,
            minlength:10
        },
        department: {
            required: true,
        },
        city: {
            required: true,
        },
        'specialty[]': {
            required: true
        },
        password: {
            required: true,
            password: true,
            minlength:8
        },
        dt: {
            required: true,
        },
        tyc: {
            required: true,
        }

    },
    messages: {
        document_type: {
            required: "Este campo es requerido",
        },
        document_number: {
            required: "Este campo es requerido",
        },
        first_name: {
            required: "Este campo es requerido",
        },
        last_name: {
            required: "Este campo es requerido",
        },
        cell_phone_1: {
            required: "Este campo es requerido",
            minlength: "Mínimo {0} caracteres",
        },
        department: {
            required: "Este campo es requerido",
        },
        city: {
            required: "Este campo es requerido",
        },
        'specialty[]': {
            required: "Este campo es requerido",
        },
        password: {
            required: "Este campo es requerido",
            minlength: "Mínimo {0} caracteres"
        },
        dt: {
            required: "Este campo es requerido",
        },
        tyc: {
            required: "Este campo es requerido",
        }
    }
});
$('.step-1').validate({
    errorPlacement: function(error, element) {
        if (error.text() != '') {
            element.parents('.form-group').next('.msn').fadeIn(0).text(error.text());
            element.addClass("is-invalid");
            //$('input, textarea').placeholder();
        }
    },
    unhighlight: function (element) {
        $(element).removeClass("is-invalid");
        $(element).parents('.form-group').next('.msn').fadeOut(0).text('');
    },
    success : function(label, element){
        $(element).removeClass("is-invalid");
        $(element).parents('.form-group').next('.msn').fadeOut(0).text('');
    },
    rules: {
        document_type: {
            required: true
        },
        document_number: {
            required: true
        },
        first_name: {
            required: true,
            names:true
        },
        second_name: {
            names:true
        },
        firts_last_name: {
            required: true,
            names:true
        },
        second_last_name: {
            names:true
        },

        password: {
            required: true,
            password: true,
            minlength:8
        },

        'specialty[]': {
            required: true
        },

        dt: {
            required: true,
        },
        tyc: {
            required: true,
        }

    },
    messages: {
        document_type: {
            required: "Este campo es requerido",
        },
        document_number: {
            required: "Este campo es requerido",
        },
        first_name: {
            required: "Este campo es requerido",
        },
        second_name: {
            required: "Este campo es requerido",
        },
        firts_last_name: {
            required: "Este campo es requerido",
        },
        second_last_name: {
            required: "Este campo es requerido",
        },
        password: {
            required: "Este campo es requerido",
            minlength: "Mínimo {0} caracteres"
        },
        'specialty[]': {
            required: "Este campo es requerido",
        },

        dt: {
            required: "Este campo es requerido",
        },
        tyc: {
            required: "Este campo es requerido",
        }
    }
});

$('.step-2').validate({
    errorPlacement: function(error, element) {
        if (error.text() != '') {
            element.parents('.form-group').next('.msn').fadeIn(0).text(error.text());
            element.addClass("is-invalid");
            //$('input, textarea').placeholder();
        }
    },
    unhighlight: function (element) {
        $(element).removeClass("is-invalid");
        $(element).parents('.form-group').next('.msn').fadeOut(0).text('');
    },
    success : function(label, element){
        $(element).removeClass("is-invalid");
        $(element).parents('.form-group').next('.msn').fadeOut(0).text('');
    },
    rules: {
        email: {
            required: true,
            email:true
        },
        cell_phone_1: {
            required: true,
            cell_phone: true,
            minlength:10
        },
        department: {
            required: true,
        },
        city: {
            required: true,
        },
    },
    messages: {
        email: {
            required: "Este campo es requerido",
            email: "El correo no es válido",
        },
        cell_phone_1: {
            required: "Este campo es requerido",
            minlength: "Mínimo {0} caracteres",
        },
        department: {
            required: "Este campo es requerido",
        },
        city: {
            required: "Este campo es requerido",
        },
    }
});

$('#async_change_password, #password-recovery-form').validate({
    errorPlacement: function(error, element) {
        if (error.text() != '') {
            element.parents('.form-group').next('.msn').fadeIn(0).text(error.text());
            element.addClass("is-invalid");
        }
    },
    unhighlight: function (element) {
        $(element).removeClass("is-invalid");
        $(element).parents('.form-group').next('.msn').fadeOut(0).text('');
    },
    success : function(label, element){
        $(element).removeClass("is-invalid");
        $(element).parents('.form-group').next('.msn').fadeOut(0).text('');
    },
    rules: {
        password: {
            required: true,
            minlength: 8,
            password:true
        },
        confirm: {
            required:true,
            minlength : 8,
            equalTo : "#password"
        }
    },
    messages: {
        password: {
            required: "Este campo es requerido",
            minlength: "La contraseña debe tener minimo {0} caracteres"
        },
        confirm: {
            required: "Este campo es requerido",
            equalTo: "Las contraseñas no coinciden",
            minlength: "La contraseña debe tener minimo {0} caracteres"
        }
    }
});

$('#register-form').validate({
    errorPlacement: function(error, element) {
        if (error.text() != '') {
            element.parents('.form-group').next('.msn').fadeIn(0).text(error.text());
            element.addClass("is-invalid");
            //$('input, textarea').placeholder();
        }
    },
    unhighlight: function (element) {
        $(element).removeClass("is-invalid");
        $(element).parents('.form-group').next('.msn').fadeOut(0).text('');
    },
    success : function(label, element){
        $(element).removeClass("is-invalid");
        $(element).parents('.form-group').next('.msn').fadeOut(0).text('');
    },
    rules: {
        dt: {
            required: true,
        },
        tyc: {
            required: true,
        },
    },
    messages: {
        dt: {
            required: "Este campo es requerido",
        },
        tyc: {
            required: "Este campo es requerido",
        },
    }
});

$.validator.addMethod("limitOfAnswer", function(value, element, params) {
    let container = $(element).closest('div.form-group');
    let limitOfAnswer = container.data('max');
    let checkedInputs = container.find('[type="checkbox"][name*="answer"]:checked');

    return checkedInputs.length <= limitOfAnswer;
}, function(element) {
    return 'Superó el máximo de respuestas permitidas';
});

$('#profile-form [type="checkbox"][name*="answer"][required]').each(function () {
    $(this).rules('add', {
        required: true,
        messages: {
            required: "Este campo es requerido"
        }
    });
});

$('#register-form [type="checkbox"][name*="answer"], #profile-form [type="checkbox"][name*="answer"]').each(function () {
    $(this).rules('add', {
        limitOfAnswer: true
    });
});

$('#register-form [type="checkbox"][name*="answer"], #profile-form [type="checkbox"][name*="answer"]').on('change', function(e) {
    let container = $(this).closest('div.form-group');
    let parent = container.closest('.question-parent');

    let hasMultipleGroups = parent.find('.form-group').length > 1;

    console.log('first', container.hasClass('first-group'));
    let isFirstGroup = container.hasClass('first-group');

    let limitOfAnswer = container.data('max');
    
    let checkedInputs = container.find('[type="checkbox"][name*="answer"]:checked');
    let uncheckedInputs = container.find('[type="checkbox"][name*="answer"]:not(:checked)');

    let label = $(this).parent().find('label');
    let labelText =  label.text().trim().toLowerCase();

    console.log('#isFirstGroup', isFirstGroup);
    
    if (hasMultipleGroups && isFirstGroup && checkedInputs.length == limitOfAnswer && ['sí', 'si', 'no'].includes(labelText)) {
        if (labelText == 'no') {
            parent.find('[type="checkbox"][name*="answer"]').not(this).prop('checked', false).prop('disabled', true);
        } else {
            parent.find('[type="checkbox"][name*="answer"]').not(this).prop('disabled', false);
        }
    }
    
    if (checkedInputs.length == limitOfAnswer) {
        uncheckedInputs.prop('disabled', true);
    } else {
        uncheckedInputs.prop('disabled', false);
    }
});


//Test
/*$('#profile-form [type="checkbox"][name*="answer"]').on('change', function() {
    $(this).closest('form').valid();
});*/

//let isFirstStepRegisterFormAjaxRunning = false;
$('.step-1').on('submit', function(e) {
    e.preventDefault();

    $('.box-de').fadeOut(0);
    //$('.step-1').valid();
    let validForm = $('.step-1').valid();
    if (!validForm) return;

    $('.ajax-message').hide().removeClass('alert-danger alert-success');

    $('.nav-tabs .active').parent().next('li').find('a').trigger('click');
    $(this).find("input[type='text']").first().focus();
});

$('.step-1-register').on('submit', function(e) {
    e.preventDefault();

    let validForm = $('.step-1-register').valid();
    if (!validForm) return;

    $('.tab-pane').removeClass('show active');
    $('.thanks-page').addClass('show active');
});

$('.back-1').on('click', function(e) {
    e.preventDefault();
    $('.box-de').fadeIn(0);
    //$('form').trigger('reset');
    $('.nav-tabs').find('#card-tab-1').trigger('click');
});

$('.back-2').on('click', function(e) {
    e.preventDefault();
    $('.nav-tabs').find('#card-tab-2').trigger('click');
});

$('.step-2').on('submit', function(e) {
    e.preventDefault();
    let validForm = $('.step-2').valid();
    if (!validForm) return;
    $('.nav-tabs .active').parent().next('li').find('a').trigger('click');
});

/*$('.step-3').on('submit', function(e) {
    e.preventDefault();
    $('.tab-pane').removeClass('show active');
    $('.thanks-page').addClass('show active');
});*/

$('#uploadBtn').on('change', function(){
    //$("#uploadFile").val($(this).val().replace("C:\\fakepath\\", ""));
    console.log('#VL', $(this).val());
    if ($(this).val() != '') {
        $(".file-box small").html('<div class="name-file"><span>'+$(this).val().replace("C:\\fakepath\\", "")+'</span><i class="lni lni-close close-tag"></i></div>');
    } else {
        $(".file-box small").html('(Se puede adjuntar imágenes, PDF y archivos de Excel y Word)');
        $('.close-tag').parents('.name-file').remove();
    }

    //$(this).parents('.file-box').find('small, span').fadeOut(0);
});

$(document).on('click','.close-tag', function() {
    $(this).parents('.name-file').remove();
    $(".file-box small").html('(Se puede adjuntar imágenes, PDF y archivos de Excel y Word)');
});

/* filter */
$('.filter-drop .box-select .print').on('click', function() {
    var total = 0;
    $(this).next().fadeIn(100);
    $(this).next().find('li').each(function(i){
        console.log(i);
        if(i <= 5) {
          total += $(this).innerHeight() + 1.3;
        }
    });
    $(this).toggleClass('open-nav');
    if($(this).hasClass('open-nav')){
        $(this).next().find('ul').css('height',total+'px');
    } else {
        $(this).next().find('ul').css('height','0px');
        $(this).next().fadeOut(400);
    }
    $('.filter-drop .box-select .print').not(this).next().find('ul').css('height','0px');
    $('.filter-drop .box-select .print').not(this).next().fadeOut(400);
    $('.filter-drop .box-select .print').not(this).removeClass('open-nav')
});
$('.filter-drop .box-select .print').next().find('li').on('click',function(){
    $(this).parents('.box-select').find('.print span').text($(this).text());
    $(this).parents('.box-select').find('.print').removeClass('open-nav');
    $(this).parent().find('ul').css('height','0px');
});
$('.filter-drop .box-select .parent-drop li').on('click', function(e) {
    e.preventDefault;
    $(this).addClass('current-nav');
    $('.filter-drop .box-select .parent-drop li').not(this).removeClass('current-nav');
    $(this).parents('.parent-drop ul').css('height','0px');
    $(this).parents('.parent-drop').fadeOut(400);
    $('.filters .box').not(this).removeClass('current');
    $(this).parents('.box').addClass('current');
});
$('.filter-drop .box:nth-of-type(1)').on('click', function() {
    $(this).addClass('current');
    $('.filter-drop .box').not(this).removeClass('current');
});


function onChange() {
    const password = document.querySelector('input[name=password]');
    const confirm = document.querySelector('input[name=confirm]');
    if (confirm.value === password.value) {
       confirm.setCustomValidity('');
    } else {
       confirm.setCustomValidity('Las contraseña no coinciden');
    }
}

$('.button-pass').on('click', onChange);

$(".clear-form").on('click', function() {
    $("#b, #d")[0].reset()
});

let isRegisterFormAjaxRunning = false;
$('#register-form, #quick-register-form').on('submit', function(e) {
    e.preventDefault()

    var validForm = $(this).valid();
    if(!validForm) {
        return
    }

    $('.ajax-message').hide().removeClass('alert-danger alert-success');

    if (isRegisterFormAjaxRunning) return;
    isRegisterFormAjaxRunning = true;

    let $form = $(this);
    let data = $('.step-1').serializeArray().concat($form.serializeArray(), $('#step-2-register-form').serializeArray());
    //let data = $form.serializeArray().append($('.step-1').serializeArray());

    $.ajax({
        method: $form.attr('method'),
        url: $form.attr('action'),
        data: data
    }).done(function(response) {
        if (response.success) {
            $form.trigger('reset');

            if (response.data.header !== undefined) {
                $('header.container-fluid.header').html(response.data.header);
            }

            $('.tab-pane').removeClass('show active');
            $('.thanks-page').addClass('show active');

            window.scrollTo(0, 0);

        } else if(response.data.message !== undefined) {
            $('.ajax-message').addClass('alert-danger');
            $('.ajax-message').html(response.data.message);
            $('.ajax-message').show();
        }

        isRegisterFormAjaxRunning = false;
    }).fail(function() {
        $('.ajax-message').addClass('alert-danger');
        $('.ajax-message').text('Se ha producido un error inesperado.');
        $('.ajax-message').show();

        isRegisterFormAjaxRunning = false;
    }).always(function() {
        isRegisterFormAjaxRunning = false;
    });
});


$('#department').on('change', function(e) {
    e.preventDefault();

    let $city = $('#city');
    let $form = $($city.closest("form"));


    $city.empty();
    $city.prop('disabled', true);

    $.ajax({
        method: 'GET',
        url: $form.attr('action'),
        data: {
            'action':'async_cities_by_department',
            'department_id': $(this).val()
        }
    }).done(function(response) {
        if (response.success) {
            $city.append($('<option>', {
                value: '',
                text: 'Ciudad*'
            }));

            $.each(response.data, function(index, item) {
                $city.append($('<option>', {
                    value: item.Id,
                    text: item.Nombre
                }));
            });


            $city.prop('disabled', false);
        }

        if ($city.val() == '' && typeof city_id !== 'undefined') {
            $('#city').val(city_id);
        }
    })
});

if (typeof city_id !== 'undefined') {
    $('#department').trigger('change');
}

$('#pqrs-form').validate({
    errorPlacement: function(error, element) {
        if (error.text() != '') {
            element.parents('.form-group').next('.msn').fadeIn(0).text(error.text());
            element.addClass("is-invalid");
            //$('input, textarea').placeholder();
        }
    },
    unhighlight: function (element) {
        $(element).removeClass("is-invalid");
        $(element).parents('.form-group').next('.msn').fadeOut(0).text('');
    },
    success : function(label, element){
        $(element).removeClass("is-invalid");
        $(element).parents('.form-group').next('.msn').fadeOut(0).text('');
    },
    rules: {
        document_type: {
            required: true,
        },
        document_number: {
            required: true
        },
        first_name: {
            required: true,
            names: true
        },
        last_name: {
            required: true,
            names: true
        },
        email: {
            required: true,
            email: true
        },
        message: {
            required: true,
        },
        dt: {
            required: true,
        },
        tyc: {
            required: true,
        },
    },
    messages: {
        document_type: {
            required: "Este campo es requerido",
        },
        document_number: {
            required: "Este campo es requerido",
        },
        first_name: {
            required: "Este campo es requerido",
        },

        last_name: {
            required: "Este campo es requerido",
        },

        email: {
            required: "Este campo es requerido",
            email: "El correo no es válido"
        },
        cell_phone_number: {
            required: "Este campo es requerido",
        },
        message: {
            required: "Este campo es requerido",
        },
        dt: {
            required: "Este campo es requerido",
        },
        tyc: {
            required: "Este campo es requerido",
        }
    }
});

let isPqrsFormAjaxRunning = false;
$('#pqrs-form').on('submit', function(e) {
    e.preventDefault()

    var validForm = $(this).valid();
    if(!validForm) {
        return
    }

    $('.ajax-message').hide().removeClass('alert-danger alert-success');

    if (isPqrsFormAjaxRunning) return;
    isPqrsFormAjaxRunning = true;

    let $form = $(this);

    $.ajax({
        method: $form.attr('method'),
        url: $form.attr('action'),
        data: new FormData(this),
        processData: false,
        contentType: false
    }).done(function(response) {
        if (response.success) {
            $form.trigger('reset');

            $('.tab-pane').removeClass('show active');
            $('.thanks-page').addClass('show active');
            $('.ajax-message').addClass('alert-success');

        } else if(response.data.message !== undefined) {
            $('.ajax-message').addClass('alert-danger');
            $('.ajax-message').html(response.data.message);
            $('.ajax-message').show();
        }
    }).fail(function() {
        $('.ajax-message').addClass('alert-danger');
        $('.ajax-message').text('Se ha producido un error inesperado.');
        $('.ajax-message').show();
    }).always(function() {
        isPqrsFormAjaxRunning = false;
    });
});

let isLoginFormAjaxRunning = false;
$('#login-form').on('submit', function(e) {
    e.preventDefault()

    $('.ajax-message').hide().removeClass('alert-danger alert-success');

    if (isLoginFormAjaxRunning) return;
    isLoginFormAjaxRunning = true;

    let $form = $(this);
    let data = $form.serializeArray().concat($('.step-1').serializeArray());

    $.ajax({
        method: $form.attr('method'),
        url: $form.attr('action'),
        data: data
    }).done(function(response) {
        if (response.success) {
            $form.trigger('reset');

            $('.tab-pane').removeClass('show active');
            $('.thanks-page').addClass('show active');

            location.href = response.data.redirect;

        } else if(response.data.message !== undefined) {
            $('.ajax-message').addClass('alert-danger');
            $('.ajax-message').html(response.data.message);
            $('.ajax-message').show();
        }
    }).fail(function() {
        $('.ajax-message').addClass('alert-danger');
        $('.ajax-message').text('Se ha producido un error inesperado.');
        $('.ajax-message').show();
    }).always(function() {
        isLoginFormAjaxRunning = false;
    });
});

let isAsyncFormAjaxRunning = false;
$('#async-form').on('submit', function(e) {
    e.preventDefault()

    $('.ajax-message').hide().removeClass('alert-danger alert-success');

    if (isAsyncFormAjaxRunning) return;
    isAsyncFormAjaxRunning = true;

    let $form = $(this);

    $.ajax({
        method: $form.attr('method'),
        url: $form.attr('action'),
        data: $form.serializeArray()
    }).done(function(response) {
        if (response.success) {
            $('.ajax-message').addClass('alert-success');
            $('.ajax-message').html(response.data.message);
        } else if(response.data.message !== undefined) {
            $('.ajax-message').addClass('alert-danger');
            $('.ajax-message').html(response.data.message);
        }s

        $('.ajax-message').show();
    }).fail(function() {
        $('.ajax-message').addClass('alert-danger');
        $('.ajax-message').text('Se ha producido un error inesperado.');
        $('.ajax-message').show();
    }).always(function() {
        isAsyncFormAjaxRunning = false;
    });
});

let isProfileFormAjaxRunning = false;
$('#profile-form').on('submit', function(e) {
    e.preventDefault();

    $('.ajax-message').hide().removeClass('alert-danger alert-success');

    //this.reportValidity()
    var validForm = $(this).valid();

    if(!validForm) {
        return;
    }

    $('.nav-tabs .active').parent().next('li').find('a').trigger('click');

    if (isProfileFormAjaxRunning) return;
    isProfileFormAjaxRunning = true;

    let $form = $(this);

    $.ajax({
        method: $form.attr('method'),
        url: $form.attr('action'),
        data: $form.serializeArray()
    }).done(function(response) {
        if (response.success) {
            $('.ajax-message').addClass('alert-success');
            $('.ajax-message').html(response.data.message);

            $('.question-parent input').prop('checked', false).prop('disabled', false);
            $('.question-textarea').val('')

        } else if(response.data.message !== undefined) {
            $('.ajax-message').addClass('alert-danger');
            $('.ajax-message').html(response.data.message);
        } else {
            $('.ajax-message').addClass('alert-danger');
        }

        $('.ajax-message').show();
    }).fail(function() {
        $('.ajax-message').addClass('alert-danger');
        $('.ajax-message').text('Se ha producido un error inesperado.');
        $('.ajax-message').show();
    }).always(function() {
        isProfileFormAjaxRunning = false;
    });
});

let isPasswordRecoveryFormAjaxRunning = false;
$('#password-recovery-form, #async_change_password').on('submit', function(e) {
    e.preventDefault();

    $('.ajax-message').hide().removeClass('alert-danger alert-success');

    var validForm = $(this).valid();
    if(!validForm) {
        return
    }

    if (isPasswordRecoveryFormAjaxRunning) return;
    isPasswordRecoveryFormAjaxRunning = true;

    let $form = $(this);

    let data = $form.serializeArray().concat($('.step-1').serializeArray());
    console.log('#data', data);

    $.ajax({
        method: $form.attr('method'),
        url: $form.attr('action'),
        data: new FormData(this),
        processData: false,
        contentType: false
    }).done(function(response) {
        if (response.success) {
            $form.trigger('reset');

            $('.tab-pane').removeClass('show active');
            $('.thanks-page').addClass('show active');
            //$('.ajax-message').addClass('alert-success');

        } else if(response.data.message !== undefined) {
            $('.ajax-message').addClass('alert-danger');
            $('.ajax-message').html(response.data.message);
            $('.ajax-message').show();
        }

        if (response.data.redirect !== undefined) {
            location.href = response.data.redirect;
        }
    }).fail(function() {
        $('.ajax-message').addClass('alert-danger');
        $('.ajax-message').text('Se ha producido un error inesperado.');
        $('.ajax-message').show();
    }).always(function() {
        isPasswordRecoveryFormAjaxRunning = false;
    });
});

function matchStart(params, data) {
    params.term = params.term || '';
    if (data.text.toUpperCase().indexOf(params.term.toUpperCase()) == 0) {
        return data;
    }

    return false;
}

/*$(".departamentor, .departamento, .ciudadr, .ciudad").select2({
    matcher: function(params, data) {
        return matchStart(params, data);
    },
});*/

/*$('#document-type').on('change', function() {

    //^[1-9]\d*$
    //(.*?)
    let $this = $(this);
    let $documentNumber = $('#document-number');



    if ($this.val() == '1') {
        $documentNumber.attr('pattern', '^[1-9]\\d*');
        $documentNumber.attr('title', 'El documento debe contener solo números y no puede iniciar con 0');
    }
    else {
        $documentNumber.attr('pattern', '^[1-9A-Za-z][0-9A-Za-z]*');
        $documentNumber.attr('title', 'El documento no puede iniciar con 0');
    }
});*/

$('input.email').on('change', function() {
    let $this = $(this);
    let $email = $($('input.email[type="text"]').not(this));

    if ($.trim($this.val()) == '') {
        $email.prop('required', false);
    } else {
        $email.prop('required', true);
    }
});

if ($('#document-type').length > 0) {
    $('#document-type').trigger('change');
}

$('select[readonly], input[readonly]').on('click', function() {
    console.log('#CLICK!');

    $('.ajax-message').addClass('alert-danger');
    $('.ajax-message').html(`Para modificar este campo debe realizar una solicitud en <a target="_blank" href="${contact_page}">contacto</a>.`).show();

    $("html, body").delay(0).animate({
        scrollTop: $('.ajax-message').offset().top
    }, 1000);
});

$('#filter-form #type, #filter-form #city, #filter-form #specialty, #filter-form #start-date').on('change', function() {
    $('#filter-form').trigger('submit');
});

let isAjaxRunning = false;
$('#filter-form').on('submit', function(e) {
    e.preventDefault();

    if (isAjaxRunning) return;
    isAjaxRunning = true;

    let $form = $(this);
    let data = $form.serializeArray();

    $.ajax({
        method: $form.attr('method'),
        url: $form.attr('action'),
        data: data
    }).done(function(html) {
        $('#item-container').html(html);
    }).fail(function() {
        $('#item-container').html('');
    }).always(function() {
        $('html, body').animate({
                scrollTop: $('#item-container').offset().top - 300
        }, 1000, 'linear');
    });

    isAjaxRunning = false;
});


//Ajax pagination item-container
$('#item-container').on('click', '.page-number', function(e) {
    e.preventDefault();
    if (isAjaxRunning) return;

    let _this = $(this);
    let clickedPage = _this.text();

    let pagination = _this.parent().parent();
    let currents = pagination.find('.current');
    currents.removeClass('current');

    $('#filter-form #current-page-number').val(clickedPage);
    $('#filter-form').trigger('submit');
});

//Next button
$('#item-container').on('click', '.page-item.last', function(e) {
    e.preventDefault();
    if (isAjaxRunning) return;

    let currentPage = $('#filter-form #current-page-number');
    let nextPageNumber = parseInt(currentPage.val()) + 1;

    currentPage.val(nextPageNumber);
    $('#filter-form').trigger('submit');
});

//Previous button
$('#item-container').on('click', '.page-item.first', function(e) {
    e.preventDefault();
    if (isAjaxRunning) return;

    let currentPage = $('#filter-form #current-page-number');
    let previousPageNumber = parseInt(currentPage.val()) + -1;

    currentPage.val(previousPageNumber);
    $('#filter-form').trigger('submit');
});

let lastDocumentNumber;
let isFirstStepRegisterFormAjaxRunning = false;
$('#step-1-register-form #document-number, #quick-register-form #document-number').on('blur', function(e) {
    if ($(this).val() == '') return;

    $('.box-de').fadeOut(0);

    let $documentNumber = $(this);
    $documentNumber.parent().removeClass('load');

    if (!$documentNumber.valid()) return;
    if (lastDocumentNumber == $documentNumber.val()) return;

    lastDocumentNumber = $documentNumber.val();

    $('.ajax-message').hide().removeClass('alert-danger alert-success');

    if (isFirstStepRegisterFormAjaxRunning) return;
    isFirstStepRegisterFormAjaxRunning = true;

    $documentNumber.parent().addClass('load');

    let $form = $('.step-1, #quick-register-form');

    $.ajax({
        method: $form.attr('method'),
        url: $form.attr('action'),
        data: {
            'action': 'async_check_document_number_availability',
            'document_number': $documentNumber.val(),
        }
    }).done(function(response) {
        if (response.success) {
            //Do nothing
        } else if(response.data.message !== undefined) {
            $('.ajax-message').addClass('alert-danger');
            $('.ajax-message').html(response.data.message);
            $('.ajax-message').show();

            $("html, body").animate({ scrollTop: $(document).height() }, 1000);
        }

        $documentNumber.parent().removeClass('load');
    }).fail(function() {
        $('.ajax-message').addClass('alert-danger');
        $('.ajax-message').text('Se ha producido un error.');
        $('.ajax-message').show();
    }).always(function() {
        $documentNumber.parent().removeClass('load');
        isFirstStepRegisterFormAjaxRunning = false;
    });
});

let isCheckUserLoginAjaxRunning = false;
$('#sign-in-form #document-number').on('blur', function(e) {
    $('.box-de').fadeOut(0);

    let $documentNumber = $(this);
    $documentNumber.parent().removeClass('custom-input load');

    if (!$documentNumber.valid()) return;
    if (lastDocumentNumber == $documentNumber.val()) return;

    lastDocumentNumber = $documentNumber.val();

    $('.ajax-message').hide().removeClass('alert-danger alert-success');

    if (isCheckUserLoginAjaxRunning) return;
    isCheckUserLoginAjaxRunning = true;

    $documentNumber.parent().addClass('custom-input load');

    $.ajax({
        method: 'post',
        url: '../wp-admin/admin-ajax.php',
        data: {
            'action': 'async_check_user_assigned_password',
            'document_number': $documentNumber.val(),
        }
    }).done(function(response) {
        if (response.success) {
            //Do nothing
        } else if(!isEmpty(response.data) && !isEmpty(response.data.message)) {
            $('.ajax-message').addClass('alert-danger');

            $('.ajax-message').html(response.data.message);
            $('.ajax-message').show();
        }

        $documentNumber.parent().removeClass('custom-input load');
    }).fail(function() {
        $('.ajax-message').addClass('alert-danger');
        $('.ajax-message').text('Se ha producido un error.');
        $('.ajax-message').show();
    }).always(function() {
        $documentNumber.parent().removeClass('custom-input load');
        isCheckUserLoginAjaxRunning = false;
    });
});

function socialWindow(url) {
    var left = (screen.width - 570) / 2;
    var top = (screen.height - 570) / 2;
    var params = "menubar=no,toolbar=no,status=no,width=570,height=570,top=" + top + ",left=" + left;
    window.open(url,"NewWindow",params);
}

function setShareLinks() {
    $(".social-share.facebook").on("click", function(e) {
        e.preventDefault();

        let url = $(this).attr('href');

        url = "https://www.facebook.com/sharer.php?u=" + url;
        socialWindow(url);
    });
}

setShareLinks();

function isEmpty(value) {
    return value === undefined || value === null || value === '';
}
document.addEventListener('DOMContentLoaded', () => {
    

    const header = document.querySelector('header');
        let lastScrollTop = 0;

        window.addEventListener('scroll', () => {
        let currentScroll = window.pageYOffset || document.documentElement.scrollTop;

        console.log(currentScroll > lastScrollTop)
        if( currentScroll > lastScrollTop && currentScroll > 65 ) {
            header.classList.add('active');
        } else if( currentScroll == 0 ) {
            header.classList.remove('active');
        }
        lastScrollTop = currentScroll;
    });

    //

    const accordionItems = document.querySelectorAll(".accordion-item");

    accordionItems.forEach(function (item) {
    const header = item.querySelector(".accordion-footer");

    header.addEventListener("click", function () {
        // Toggle the active class on the clicked item
        item.classList.toggle("active");

        // Hide or show the content based on the active class
        const content = item.querySelector(".accordion-content");
        content.style.display = item.classList.contains("active") ? "block" : "none";

        // Collapse other items if necessary
        if (item.classList.contains("active")) {
        accordionItems.forEach(function (otherItem) {
            if (otherItem !== item && otherItem.classList.contains("active")) {
            otherItem.classList.remove("active");
            otherItem.querySelector(".accordion-content").style.display = "none";
            }
        });
        }
    });
    });
});
